import React from 'react';


import { NotFound } from '../Pages/NotFound/NotFound';
import { TermsOfUse } from '../Pages/InfoPages/TermsOfUse';
import {PrivacyPolicies} from '../Pages/InfoPages/PrivacyPolicies';
import {PasswordResetRequest} from '../Pages/PasswordResetRequest/PasswordResetRequest';
import {RestorePassword} from '../Pages/RestorePassword/RestorePassword';
import {AprobarJWT} from '../Pages/AprobarJWT/AprobarJWT';
import {ZendeskSSO} from '../Pages/ZendDesk/ZendeskSSO';
import {ZendDeskLogOut} from '../Pages/ZendDesk/ZendDeskLogOut';
import {LoginMigration} from '../Pages/Migration/LoginMigration';
import {MigrationTable} from '../Pages/Migration/MigrationTable';
import {Auth0Callback} from '../Pages/Login/Auth0Callback';
import {Login} from '../Pages/Login/Login';
import {AdmonUsersPage} from '../Pages/Users/AdmonUsersPage';
import {UserFormPage} from '../Pages/AddEditUserPage/UserFormPage';
import {UsersInfoPage} from '../Pages/Users/UsersInfoPage';

export interface RoutesType {
    path: string;
    component: React.ComponentType;
    isPrivate: boolean
}

export const routes:RoutesType[] = [
    {
        path:'/',
        component:AdmonUsersPage,
        isPrivate: true
    },
    {
        path:'/unblock/:userID',
        component:AdmonUsersPage,
        isPrivate: true
    },
    {
        path:'/add-user',
        component:UserFormPage,
        isPrivate: true
    },
    {
        path:'/edit-user/:userID',
        component:UserFormPage,
        isPrivate: true
    },
    {
        path:'/edit-user/:userID/:tabKey',
        component:UserFormPage,
        isPrivate: true
    },
    {
        path:'/terms-of-use',
        component:TermsOfUse,
        isPrivate: false
    },
    {
        path:'/privacy-policies',
        component:PrivacyPolicies,
        isPrivate: false
    },
    {
        path:'/password-reset-request',
        component:PasswordResetRequest,
        isPrivate: false
    },
    {
        path:'/login',
        component:Login,
        isPrivate: false
    },
    {
        path:'/forgot-password',
        component:PasswordResetRequest,
        isPrivate: false
    },
    {
        path:'/restore_password/:tokenRestore',
        component:RestorePassword,
        isPrivate: false
    },
    {
        path:'/aprobar/:tokenJWT',
        component:AprobarJWT,
        isPrivate: false
    },
    {
        path:'/zendesk/sso',
        component:ZendeskSSO,
        isPrivate: false
    },
    {
        path:'/zendesk/logout',
        component:ZendDeskLogOut,
        isPrivate: false
    },
    {
        path:'/migration',
        component:LoginMigration,
        isPrivate: false
    },
    {
        path:'/migration/table',
        component:MigrationTable,
        isPrivate: true
    },
    {
        path:'/auth/callback',
        component:Auth0Callback,
        isPrivate: false
    },
    {
        path:'/user-info/:companyStr',
        component:UsersInfoPage,
        isPrivate: false
    },
    {
        path:'/*',
        component:NotFound,
        isPrivate: false
    }
];
